require('../../modules/es6.string.includes');
module.exports = require('../../modules/_core').String.includes;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/string/includes.js
// module id = 288
// module chunks = 0